import { TranslationsState } from './translations.state';

export const selectTranslationsLoading = (state: {
  translations: TranslationsState;
}) => state.translations.loading;

export const selectTranslationsError = (state: {
  translations: TranslationsState;
}) => state.translations.error;
